module.exports = __webpack_public_path__ + "img/2026-01.fe8e11fb.jpg";